import type { FieldError, Merge } from 'react-hook-form';

/**
 * Only show validation when there is an error, meaning no green border on skapa-components when
 * input is valid.
 */
export const shouldValidate = (
  error: Merge<FieldError, Array<FieldError | undefined>> | undefined
): boolean => !!error;

/**
 * Checks if array contains element
 * @param array Array with elements
 * @param element Element to find
 * @returns True if element exists in array, otherwise false
 */
export const contains = <T>(array: T[], element: T) => array.some((value) => value === element);

/**
 * Returns the last day the month for the given date
 */
export const lastDayOfMonth = (date: Date): number =>
  new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();

/**
 * Convenience function for mapping over an object/record
 *
 * @returns A new object/record with the same props but all values had the mapFunction applied to them
 */
export const mapRecord = <From, To, Keys extends string>(
  record: Record<Keys, From>,
  mapFunction: (value: From) => To
): Record<Keys, To> => {
  return Object.fromEntries<To>(
    Object.entries<From>(record).map(([key, value]) => [key, mapFunction(value)])
  ) as Record<Keys, To>;
};
